import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '@/views/customer/applicationManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { cryptoDecrypt } from '@/utils/aes';
import { TITLETOPCOFIGURE } from './../../utils';
import colorModel from './colorModel.vue';
export default {
  components: {
    colorModel
  },
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      action: uploadFile,
      uploadStatus: false,
      form: {
        isDisplayNavigation: true,
        titleColor: '#000',
        backgroundColor: '#fff',
        backgroundImage: '',
        themeColor: '#FF6B00',
        pageDescription: false,
        pageDescriptionConfig: {
          position: 'top',
          content: ''
        },
        pagePopUp: false,
        pagePopUpConfig: {
          popUpPosition: 'bottom',
          buttonName: '',
          buttonEvent: 'close',
          popUpContent: '',
          popUpTitle: '',
          buttonFontColor: '#fff',
          buttonBgColor: '#FF6B00'
        },
        pageTitle: ''
      },
      loading: false,
      fileList: [],
      colorShow: false,
      previewVisible: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      Object.assign(this.form, this.styleObj);
      this.form.pageTitle = this.$t(this.form.pageTitle);
      this.form.pagePopUpConfig.buttonBgColor = this.form.themeColor;
      this.form.pagePopUpConfig.backgroundColor = this.form.backgroundColor;
      if (this.styleObj.backgroundImage) {
        this.fileList = [{
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url: this.styleObj.backgroundImage
        }];
      }
    });
  },
  methods: {
    // 页面说明
    onChangePageLabel(e, key) {
      this.form[key] = e.target.checked;
      if (key == 'pageDescription') {
        this.form.pageDescriptionConfig = {
          position: 'top',
          content: ''
        };
        this.changeFun(false);
      } else {
        this.form.pagePopUpConfig.popUpPosition = 'bottom';
        this.form.pagePopUpConfig.buttonName = '';
        this.form.pagePopUpConfig.buttonEvent = 'close';
        this.changeFun(true);
      }
    },
    handleChange({
      fileList
    }) {
      console.log(fileList, 222);
      if (fileList.length == 0) {
        this.fileList = [];
        this.form.backgroundImage = '';
        this.changeFun(false);
        return false;
      } else if (this.uploadStatus == false) {
        this.fileList = [];
        this.form.backgroundImage = '';
        this.changeFun(false);
        return false;
      }
      let url = '';
      this.fileList = fileList.map(file => {
        console.log(file, 111);
        console.log(file.name, 2222222);
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
          url = file.url;
        }
        return file;
      });
      console.log(url, 22);
      if (url) {
        this.form.backgroundImage = url;
        this.changeFun(false);
      }
    },
    changeFun(showPage = false) {
      this.$emit('itemChange', this.form, showPage);
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请上传正确的图片格式,例如') + ':jpg,png,jpeg');
      }
      const isLt5k = file.size / 1024 < 500;
      if (!isLt5k) {
        this.$message.error(this.$t('上传图片应小于') + '500kb');
      }
      const fileName = file.name.indexOf(' ') == -1;
      console.log(fileName, "=================beforeUpload fileName==================");
      if (!fileName) {
        this.$message.error(this.$t('图片名称不能包含空格'));
      }
      this.uploadStatus = isJpgOrPng && isLt5k && fileName;
      console.log(this.uploadStatus, "=================beforeUpload isJpgOrPng && isLt5k && fileName==================");
      return this.uploadStatus;
    },
    defaultFun() {
      let copyEmpty = recursionCopy(TITLETOPCOFIGURE);
      const newEmpty = Object.assign({}, copyEmpty, {
        pageTitle: this.$t(this.pageTitle)
      });
      console.log(newEmpty, 'newEmpty', this.pageTitle);
      this.form = newEmpty;
      this.fileList = [];
      this.changeFun(false);
    },
    colorClickFun(val, key) {
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      this.form[key] = val;
      this.changeFun(false);
      this.colorShow = false;
    },
    // 页面标题去除前后空格
    handleBlurTrim(e) {
      this.form.pageTitle = e.target.value.trim();
      // this.$emit('pageTitleChange', this.form.pageTitle);
      this.changeFun(false);
    }
  }
};